import { useParams } from 'react-router-dom';
import AgentBuilder from '../components/AgentBuilder';

const DuplicateAgent = () => {
  const { id } = useParams();

  return <AgentBuilder agentId={id} isDuplicate />;
};

export default DuplicateAgent;
